if (!customElements.get('fullwidth-slider')) {
  class FullWidthSlider extends HTMLElement {
    constructor() {
      super();
      this.isDisabled = this.hasAttribute('data-disabled');
    }

    connectedCallback() {
      if(this.isDisabled || !Flickity) return;

      this.slider = new Flickity(this, {
        wrapAround: true,
        pageDots: true,
        cellAlign: 'left'
      });
    }
  }

  customElements.define('fullwidth-slider', FullWidthSlider);
}
